import React from 'react';
import { FaArrowLeft, FaShieldAlt, FaCheckCircle } from 'react-icons/fa';

const CertificateView = ({ setCurrentView }) => {
  return (
    <div className="certificate-container">
      <div className="certificate-header">
        <button className="certificate-back-btn" onClick={() => setCurrentView('main')}>
          <FaArrowLeft /> Back
        </button>
        <h4>Company Compliance</h4>
      </div>
      
      <div className="certificate-content">
        <div className="certificate-card">
          <div className="certificate-icon">
            <FaShieldAlt className="shield-icon" />
          </div>
          <h3>Official Business Certificate</h3>
          <div className="certificate-image">
            <img 
              src="/certificate.PNG"
              alt="Vision Tech Certificate" 
              className="cert-img"
            />
          </div>
          <div className="certificate-verification">
            <FaCheckCircle className="verify-icon" />
            <span>Verified & Authenticated</span>
          </div>
        </div>

        <div className="company-description">
          <h4>Vision Tech Company</h4>
          <div className="description-content">
            <p>VisionTech is a Silicon Valley-based company revolutionizing industries through advanced technology solutions. This year, we expanded to Kenya, creating a hub to drive innovation and impact.

Our platform empowers businesses with scalable, efficient tools while offering exciting opportunities for Tesla product investments. By investing, you join a mission to shape the future with sustainable and intelligent innovations.

We welcome trailblazers to our dynamic team, where creativity and collaboration redefine progress. With VisionTech Kenya, we're transforming communities, industries, and the investment landscape. Be part of the journey to drive innovation and sustainable growth!</p>
            <p>Vision Tech is a fully registered and compliant technology investment company, officially recognized by relevant authorities. Our registration number demonstrates our commitment to operating within legal frameworks while delivering innovative investment solutions.</p>
            <div className="compliance-points">
              <div className="compliance-item">
                <FaCheckCircle className="check-icon" />
                <span>Registered Business Entity</span>
              </div>
              <div className="compliance-item">
                <FaCheckCircle className="check-icon" />
                <span>Complete Verified Operations</span>
              </div>
              <div className="compliance-item">
                <FaCheckCircle className="check-icon" />
                <span>Secure Investment Platform</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateView;
